import { render, staticRenderFns } from "./SavedFilters.vue?vue&type=template&id=3dd33672&scoped=true"
import script from "./SavedFilters.vue?vue&type=script&lang=js"
export * from "./SavedFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd33672",
  null
  
)

export default component.exports